import { useState, useContext, useEffect } from 'react';
import { COUNTER_MODE, MAX_KICK, MAX_TIME } from '../constants/constants';
import { KickCounterContext } from '../context/KickCounterContext';

const useEndSession = () => {
  const {
    kickList, time, counterMode,
  } = useContext(KickCounterContext);
  const [sessionShouldEnd, setSessionShouldEnd] = useState(false);

  useEffect(() => {
    if ((kickList.length >= MAX_KICK && counterMode === COUNTER_MODE.KICK)
    || (time >= MAX_TIME && counterMode === COUNTER_MODE.TIME)) {
      setSessionShouldEnd(true);
    }
  }, [time, kickList]);

  return sessionShouldEnd;
};

export default useEndSession;
